import { render, staticRenderFns } from "./ChartjsBarChart.vue?vue&type=template&id=972d9e74&"
import script from "./ChartjsBarChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972d9e74')) {
      api.createRecord('972d9e74', component.options)
    } else {
      api.reload('972d9e74', component.options)
    }
    module.hot.accept("./ChartjsBarChart.vue?vue&type=template&id=972d9e74&", function () {
      api.rerender('972d9e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/production/ChartjsBarChart.vue"
export default component.exports